"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisClientManager = exports.BufferSourceAudioTrackPackage = exports.AudioTrackPackage = exports.VideoTrackPackage = exports.RemoteUserPackage = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const BaseType_1 = require("../base/BaseType");
const DefaultValue_1 = require("../base/DefaultValue");
const IrisClientObserver_1 = require("./IrisClientObserver");
const IrisRtcEngine_1 = require("./IrisRtcEngine");
class RemoteUserPackage {
    constructor(connection, element, videoPlayerConfig = DefaultValue_1.defaultVideoPlayerConfig, uid, videoSourceType, audioSourceType) {
        this.connection = connection;
        this.element = element;
        this.videoPlayerConfig = videoPlayerConfig;
        this.uid = uid;
        this.videoSourceType = videoSourceType;
        this.audioSourceType = audioSourceType;
    }
    dispose() { }
}
exports.RemoteUserPackage = RemoteUserPackage;
class VideoTrackPackage {
    constructor(element, videoPlayerConfig = DefaultValue_1.defaultVideoPlayerConfig, type, track) {
        this.isPreview = false;
        this.element = element;
        this.videoPlayerConfig = videoPlayerConfig;
        this.type = type;
        this.track = track;
    }
    dispose() {
        this.isPreview = false;
        try {
            if (this.track) {
                if (this.track.isPlaying) {
                    this.track.stop();
                }
                // Fix indicatore browser persistente: close() deve essere chiamato sempre
                // (non solo se enabled=true). processVideoTrackClose chiama setEnabled(false)
                // PRIMA di questa dispose, quindi il check .enabled falliva e close() veniva
                // saltato — il MediaStreamTrack sottostante non veniva fermato e
                // l'indicatore camera/schermo del browser restava acceso dopo stop share,
                // leave e kick.
                this.track.close();
            }
        }
        catch (_a) { }
    }
}
exports.VideoTrackPackage = VideoTrackPackage;
class AudioTrackPackage {
    constructor(type, track) {
        this.type = type;
        this.track = track;
    }
    dispose() {
        try {
            if (this.track) {
                if (this.track.isPlaying) {
                    this.track.stop();
                }
                this.track.close();
            }
        }
        catch (_a) { }
    }
}
exports.AudioTrackPackage = AudioTrackPackage;
class BufferSourceAudioTrackPackage extends AudioTrackPackage {
    constructor(type, track, soundId) {
        super(type, track);
        this.type = type;
        this.track = track;
        this.soundId = soundId;
    }
    dispose() {
        super.dispose();
    }
}
exports.BufferSourceAudioTrackPackage = BufferSourceAudioTrackPackage;
// 存放一堆东西的
class IrisClientManager {
    constructor(engine) {
        this.irisClientList = [];
        this.localVideoTrackPackages = [];
        this.localAudioTrackPackages = [];
        this.trackEventHandlers = new Array();
        this.userInfoList = new Array();
        this.remoteUserPackages = new Array();
        this._engine = engine;
        this.irisClientObserver = new IrisClientObserver_1.IrisClientObserver(engine);
    }
    addLocalVideoTrackPackage(videoTrackPackage) {
        this.localVideoTrackPackages.push(videoTrackPackage);
        this.irisClientObserver.addVideoTrackPackageObserver(videoTrackPackage);
    }
    removeLocalVideoTrackPackage(videoTrackPackage) {
        for (let i = 0; i < this.localVideoTrackPackages.length; i++) {
            let trackPackage = this.localVideoTrackPackages[i];
            if (trackPackage.track == videoTrackPackage.track &&
                trackPackage.type == trackPackage.type) {
                this.localVideoTrackPackages.splice(i, 1);
                i--;
                this.irisClientObserver.removeVideoTrackPackageObserver(videoTrackPackage);
                videoTrackPackage.dispose();
                break;
            }
        }
    }
    getLocalVideoTrackPackageBySourceType(sourceType) {
        return this.localVideoTrackPackages.filter((trackPackage) => {
            if (Array.isArray(sourceType)) {
                for (let type of sourceType) {
                    if (trackPackage.type == type) {
                        return true;
                    }
                }
            }
            else {
                return trackPackage.type == sourceType;
            }
        });
    }
    getLocalVideoTrackPackageByConnection(connection) {
        return this.localVideoTrackPackages.filter((trackPackage) => {
            var _a, _b, _c, _d;
            return (((_b = (_a = trackPackage === null || trackPackage === void 0 ? void 0 : trackPackage.irisClient) === null || _a === void 0 ? void 0 : _a.connection) === null || _b === void 0 ? void 0 : _b.channelId) ===
                connection.channelId &&
                ((_d = (_c = trackPackage === null || trackPackage === void 0 ? void 0 : trackPackage.irisClient) === null || _c === void 0 ? void 0 : _c.connection) === null || _d === void 0 ? void 0 : _d.localUid) === connection.localUid);
        });
    }
    addLocalAudioTrackPackage(audioTrackPackage) {
        this.localAudioTrackPackages.push(audioTrackPackage);
        this.irisClientObserver.addAudioTrackPackageObserver(audioTrackPackage);
    }
    getLocalAudioTrackPackageBySourceType(sourceType) {
        return this.localAudioTrackPackages.filter((trackPackage) => {
            if (Array.isArray(sourceType)) {
                for (let type of sourceType) {
                    if (trackPackage.type == type) {
                        return true;
                    }
                }
            }
            else {
                return trackPackage.type == sourceType;
            }
        });
    }
    getLocalAudioTrackPackageByConnection(connection) {
        return this.localAudioTrackPackages.filter((trackPackage) => {
            var _a, _b, _c, _d;
            return (((_b = (_a = trackPackage === null || trackPackage === void 0 ? void 0 : trackPackage.irisClient) === null || _a === void 0 ? void 0 : _a.connection) === null || _b === void 0 ? void 0 : _b.channelId) ===
                connection.channelId &&
                ((_d = (_c = trackPackage === null || trackPackage === void 0 ? void 0 : trackPackage.irisClient) === null || _c === void 0 ? void 0 : _c.connection) === null || _d === void 0 ? void 0 : _d.localUid) === connection.localUid);
        });
    }
    removeLocalAudioTrackPackage(audioTrackPackage) {
        for (let i = 0; i < this.localAudioTrackPackages.length; i++) {
            let trackPackage = this.localAudioTrackPackages[i];
            if (trackPackage.track == audioTrackPackage.track &&
                trackPackage.type == trackPackage.type) {
                this.localAudioTrackPackages.splice(i, 1);
                i--;
                this.irisClientObserver.removeAudioTrackPackageObserver(audioTrackPackage);
                audioTrackPackage.dispose();
                break;
            }
        }
    }
    getRemoteUserPackageByUid(uid) {
        return this.remoteUserPackages.filter((remoteUserPackage) => {
            return remoteUserPackage.uid == uid;
        })[0];
    }
    getRemoteUserPackagesByConnection(connection) {
        return this.remoteUserPackages.filter((remoteUserPackage) => {
            var _a;
            return ((_a = remoteUserPackage.connection) === null || _a === void 0 ? void 0 : _a.channelId) === connection.channelId;
        });
    }
    addRemoteUserPackage(remoteUserPackage, agoraRTCClient) {
        // AUDIT-v18: dedup. Se un pkg con stesso uid+connection esiste già (race
        // setupRemoteVideoEx pre-create + user-joined), skip push. Evita double
        // push → double remove → double interval clear.
        if (remoteUserPackage.uid != null &&
            remoteUserPackage.uid !== 0 &&
            this.remoteUserPackages.some((p) => {
                var _a, _b;
                return p.uid === remoteUserPackage.uid &&
                    ((_a = p.connection) === null || _a === void 0 ? void 0 : _a.channelId) === ((_b = remoteUserPackage.connection) === null || _b === void 0 ? void 0 : _b.channelId);
            })) {
            return;
        }
        this.remoteUserPackages.push(remoteUserPackage);
        this.irisClientObserver.addRemoteUserPackageObserver(remoteUserPackage);
        if (agoraRTCClient) {
            let intervalFunction = setInterval(() => {
                var _a, _b;
                // AUDIT-v18: guard su agoraRTCClient disconnesso. Interval può persistere
                // ~1 tick dopo leaveChannel (setInterval fired già in queue). Accesso a
                // getRemoteNetworkQuality su client rilasciato throw → eccezione in tick.
                if (!agoraRTCClient || !agoraRTCClient.channelName) {
                    return;
                }
                try {
                    let stats = agoraRTCClient.getRemoteNetworkQuality();
                    let connection = {
                        channelId: agoraRTCClient.channelName,
                        localUid: agoraRTCClient.uid,
                    };
                    this._engine.rtcEngineEventHandler.onNetworkQuality_34d8b3c(connection, remoteUserPackage.uid, (_a = stats[remoteUserPackage.uid]) === null || _a === void 0 ? void 0 : _a.downlinkNetworkQuality, (_b = stats[remoteUserPackage.uid]) === null || _b === void 0 ? void 0 : _b.uplinkNetworkQuality);
                }
                catch (e) {
                    // swallow — tick successivo riproverà o interval verrà pulito
                }
            }, this._engine.globalState.networkQualityInterval);
            this._engine.addIrisInterval(IrisRtcEngine_1.IrisIntervalType.networkQuality, intervalFunction, remoteUserPackage.uid);
        }
    }
    removeRemoteUserPackage(uid) {
        for (let i = 0; i < this.remoteUserPackages.length; i++) {
            let userPackage = this.remoteUserPackages[i];
            if (userPackage.uid == uid) {
                this.remoteUserPackages.splice(i, 1);
                i--;
                this.irisClientObserver.removeRemoteUserPackageObserver(userPackage);
                this._engine.removeIrisIntervalByUid(uid);
                userPackage.dispose();
                break;
            }
        }
    }
    getVideoFrame(uid, channel_id) {
        this._engine.irisClientManager.irisClientList.map((irisClient) => {
            var _a, _b, _c;
            //当存在于本地
            if (((_a = irisClient.agoraRTCClient) === null || _a === void 0 ? void 0 : _a.channelName) == channel_id &&
                irisClient.agoraRTCClient.uid == uid) {
                return {
                    video_track: (_b = irisClient.videoTrackPackage) === null || _b === void 0 ? void 0 : _b.track,
                    is_new_frame: true, //todo  how to know is a new frame
                    process_err: BaseType_1.IRIS_VIDEO_PROCESS_ERR.ERR_OK,
                };
            }
            else {
                if (((_c = irisClient.agoraRTCClient) === null || _c === void 0 ? void 0 : _c.channelName) == channel_id) {
                    irisClient.agoraRTCClient.remoteUsers.map((remoteUser) => {
                        if (remoteUser.uid == uid &&
                            remoteUser.hasVideo &&
                            remoteUser.videoTrack) {
                            return {
                                video_track: remoteUser.videoTrack,
                                is_new_frame: true, //todo  how to know is a new frame
                                process_err: BaseType_1.IRIS_VIDEO_PROCESS_ERR.ERR_OK,
                            };
                        }
                    });
                }
            }
        });
        return null;
    }
    getVideoFrameByConfig(config) {
        let uid = config.id;
        let channel_id = config.key;
        let type = config.type;
        this._engine.irisClientManager.irisClientList.map((irisClient) => {
            var _a, _b;
            //当存在于本地
            if (((_a = irisClient.videoTrackPackage) === null || _a === void 0 ? void 0 : _a.type) == type) {
                return {
                    video_track: irisClient.videoTrackPackage.track,
                    is_new_frame: true, //todo  how to know is a new frame
                    process_err: BaseType_1.IRIS_VIDEO_PROCESS_ERR.ERR_OK,
                };
            }
            else {
                if (((_b = irisClient.agoraRTCClient) === null || _b === void 0 ? void 0 : _b.channelName) == channel_id) {
                    irisClient.agoraRTCClient.remoteUsers.map((remoteUser) => {
                        if (remoteUser.uid == uid &&
                            remoteUser.hasVideo &&
                            remoteUser.videoTrack) {
                            return {
                                video_track: remoteUser.videoTrack,
                                is_new_frame: true, //todo  how to know is a new frame
                                process_err: BaseType_1.IRIS_VIDEO_PROCESS_ERR.ERR_OK,
                            };
                        }
                    });
                }
            }
        });
        return null;
    }
    getIrisClient() {
        return this.irisClientList[0];
    }
    getIrisClientByConnection(connection) {
        if (connection) {
            return this.irisClientList.filter((irisClient) => {
                var _a, _b;
                if (((_a = irisClient.connection) === null || _a === void 0 ? void 0 : _a.channelId) == connection.channelId &&
                    ((_b = irisClient.connection) === null || _b === void 0 ? void 0 : _b.localUid) == connection.localUid) {
                    return irisClient;
                }
            })[0];
        }
        else {
            return this.getIrisClient();
        }
    }
    getScreenCaptureStatus() {
        let result = false;
        let videoTrackPackages = this.getLocalVideoTrackPackageBySourceType([
            NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_PRIMARY,
            NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_SECONDARY,
            NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_THIRD,
            NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_FOURTH,
        ]);
        videoTrackPackages.map((videoTrackPackage) => {
            if (videoTrackPackage.track) {
                result = true;
                return;
            }
        });
        return result;
    }
    addTrackEventHandler(trackEventHandler) { }
    removeTrackEventHandlerByTrack(track) {
        for (let i = 0; i < this.trackEventHandlers.length; i++) {
            let trackEventHandler = this.trackEventHandlers[i];
            if (trackEventHandler.getTrack() == track) {
                trackEventHandler.release();
                this.trackEventHandlers.splice(i, 1);
                i--;
                break;
            }
        }
    }
    removetrackEventHandlerByRemoteUser(user, mediaType) {
        this.trackEventHandlers = this.trackEventHandlers.filter((trackEventHandler) => {
            if (trackEventHandler.getRemoteUser() != user)
                return true;
            if (mediaType == 'all') {
                trackEventHandler.release();
                return false;
            }
            if (mediaType == 'audio' &&
                trackEventHandler.getTrackType() == 'IRemoteTrack') {
                trackEventHandler.release();
                return false;
            }
            if (mediaType == 'video' &&
                trackEventHandler.getTrackType() == 'IRemoteVideoTrack') {
                trackEventHandler.release();
                return false;
            }
            return true;
        });
    }
    processBufferSourceAudioTrackClose(bufferSourceAudioTrackPackage) {
        return __awaiter(this, void 0, void 0, function* () {
            let track = bufferSourceAudioTrackPackage.track;
            //删除完毕后进行stop,close
            track.stopProcessAudioBuffer();
            track.close();
            this.removeTrackEventHandlerByTrack(track);
        });
    }
    processAudioTrackClose(audioTrackPackage) {
        return __awaiter(this, void 0, void 0, function* () {
            let audioTrack = audioTrackPackage.track;
            //删除完毕后进行stop
            if (audioTrack.isPlaying) {
                this._engine.trackHelper.stop(audioTrack);
            }
            if (!audioTrack.muted) {
                if (audioTrackPackage.type !==
                    BaseType_1.IrisAudioSourceType.kAudioSourceTypeScreenCapture) {
                    yield this._engine.trackHelper.setEnabled(audioTrack, false);
                }
            }
            this.removeTrackEventHandlerByTrack(audioTrack);
        });
    }
    processVideoTrackClose(videoTrackPackage) {
        return __awaiter(this, void 0, void 0, function* () {
            let videoTrack = videoTrackPackage.track;
            //如果isPreview是false则停止播放以及设置为不可用
            if (!videoTrackPackage.isPreview) {
                if (videoTrack.isPlaying) {
                    this._engine.trackHelper.stop(videoTrack);
                }
                if (!videoTrack.muted) {
                    yield this._engine.trackHelper.setEnabled(videoTrack, false);
                }
            }
            this.removeTrackEventHandlerByTrack(videoTrack);
        });
    }
    addUserInfo(userInfo) {
        if (!this.userInfoList.some((user) => user.uid === userInfo.uid)) {
            this.userInfoList.push(userInfo);
        }
    }
    removeUserInfoByUid(uid) {
        const index = this.userInfoList.findIndex((user) => user.uid === uid);
        if (index !== -1) {
            this.userInfoList.splice(index, 1);
        }
    }
    getUserInfoByUid(uid) {
        return this.userInfoList.find((userInfo) => userInfo.uid === uid);
    }
    getUserInfoByUserAccount(userAccount) {
        return this.userInfoList.find((userInfo) => userInfo.userAccount === userAccount);
    }
    release() {
        return __awaiter(this, void 0, void 0, function* () {
            this._engine.clearIrisInterval();
            //销毁iris html element
            this._engine.irisElement.release();
            //释放所有
            this.localVideoTrackPackages.map((trackPackage) => {
                trackPackage.dispose();
            });
            this.localAudioTrackPackages.map((trackPackage) => {
                trackPackage.dispose();
            });
            for (let irisClient of this.irisClientList) {
                yield irisClient.release();
            }
            //trackEvent
            this.trackEventHandlers.forEach((element) => {
                element.release();
            });
            //重置IrisClientManager状态
            this.irisClientList = [];
            this.userInfoList = [];
            this.localAudioTrackPackages = [];
            this.localVideoTrackPackages = [];
            this.trackEventHandlers = [];
            this.irisClientObserver.release();
        });
    }
}
exports.IrisClientManager = IrisClientManager;
